.wrap {
  padding: 38px 20px 46px;
  text-align: center;
}
.names {
  font-family: var(--font-script);
  font-weight: 400;
  font-size: 28px;
  color: var(--ink-2);
}
.heart {
  color: var(--pink);
}
.meta {
  margin-top: 6px;
  font-family: var(--font-label);
  font-size: 11.5px;
  color: var(--muted-3);
  letter-spacing: 2px;
}
